var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products-errors-view"
  }, [_c('table', [_vm._m(0), _vm._v(" "), (_vm.productErrors[0] && _vm.productErrors[0].entries) ? _c('tbody', _vm._l((_vm.productErrors[0].entries), function(error) {
    return _c('tr', {
      key: error.occuredAt
    }, [_c('td', [_vm._v(_vm._s(error.occurredAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(error.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(error.step))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(error.message))])])
  })) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Wann")]), _vm._v(" "), _c('th', [_vm._v("Warum")]), _vm._v(" "), _c('th', [_vm._v("Wo")]), _vm._v(" "), _c('th', [_vm._v("Genaueres")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b60e1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/ErrorsView.vue
// module id = 1876
// module chunks = 0